"use client";

import React from "react";

import { iconColor } from "./colors";
import { createSVGIcon } from "./createSVGIcon";
import { iconCls } from "./tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1657))
 * @lastsynced 2026-10-29T13:55:02.638Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Twinkle = createSVGIcon(
  <path
    d="M10.5 5c0 5.696 2.886 8.886 9.5 9-6.133 0-9.14 3.076-9.5 9 0-5.582-2.646-9-9.5-9 6.133-.114 9.5-2.848 9.5-9ZM19 1c0 2.588 1.177 4 4 4-2.588 0-3.882 1.412-4 4 0-2.47-1.177-4-4-4 2.588 0 4-1.176 4-4Z"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Twinkle",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
